import api from '@/utils/axios';

export const fetchGlobalAudit = async ({
  limit = 50,
  offset = 0,
  date_from = null,
  date_to = null,
  entity_type = null,
  action = null,
  search = null,
  employee_hr_id = null,
} = {}) => {
  const body = { limit, offset };
  if (date_from) body.date_from = date_from;
  if (date_to) body.date_to = date_to;
  if (entity_type) body.entity_type = entity_type;
  if (action) body.action = action;
  if (search) body.search = search;
  const employeeHrId = Number(employee_hr_id);
  if (Number.isInteger(employeeHrId) && employeeHrId > 0) {
    body.employee_hr_id = employeeHrId;
  }

  const response = await api.post('audit/global/get', body);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to load change log');
  }
  const data = response.data.data || {};
  return {
    entries: Array.isArray(data.entries) ? data.entries : [],
    total: Number(data.total || 0),
    limit: Number(data.limit || limit),
    offset: Number(data.offset || offset),
  };
};
